export function priceFormat(price: number, digits = 0): string{
  return (price / 100).toFixed(digits);
}